import http from '@util/http';
import { incubator } from '@api/req';

export async function queryIncuStationList(params) {
  return http.get(incubator.INCUBATOR_STATION_LIST, params);
}

export async function querySaveIncuStationConfig(params) {
  return http.post(incubator.INCUBATOR_STATION_CONFIG, params);
}

export async function queryAddIncuStation(params) {
  return http.get(incubator.INCUBATOR_STATION_ADD, params);
}

export async function queryIncuStationConfig(params) {
  return http.get(incubator.INCUBATOR_STATION_CONFIG_INFO, params);
}

export async function querySaveIncuStation(params) {
  return http.post(incubator.INCUBATOR_STATION_SAVE, params);
}

export async function queryDeleteIncuStation(params) {
  return http.post(incubator.INCUBATOR_STATION_DELETE, params);
}

export async function queryEnableIncuStation(params) {
  return http.post(incubator.INCUBATOR_STATION_ENABLE, params);
}

export async function queryDisableIncuStation(params) {
  return http.post(incubator.INCUBATOR_STATION_DISABLE, params);
}

export async function queryUnitIncuStation(params) {
  return http.post(incubator.INCUBATOR_STATION_UNIT, params);
}

export async function queryResetIncuStation(params) {
  return http.post(incubator.INCUBATOR_STATION_RESET, params);
}

export async function queryIncuStationCount(params) {
  return http.get(incubator.INCUBATOR_STATION_COUNT, params);
}

export async function queryIncuStationStatic(params) {
  return http.get(incubator.INCUBATOR_STATION_STATISTIC, params);
}



// WEBPACK FOOTER //
// ./src/api/incubator/station.js